import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import Loader from 'components/Loader';

// ==============================|| AUTH GUARD ||============================== //

const CLIENTE_ROLE = 'Cliente';
const PORTAL_HOME = '/portal/tickets';

export default function AuthGuard({ children }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Cliente (portal externo) não acessa painel interno — sempre redireciona
  // pra área dele. Backend já bloqueia, mas evita carregar pages quebradas.
  const ehCliente = user?.role === CLIENTE_ROLE;
  const dentroDoPortal = location.pathname.startsWith('/portal');
  if (ehCliente && !dentroDoPortal) {
    return <Navigate to={PORTAL_HOME} replace />;
  }

  return children;
}
